import React from 'react'
import { Edit } from 'react-admin'
import WithDeleteModalToolbar from 'ui-shared/CustomToolbars/WithDeleteModalToolbar'
import ProductSectionForm from 'ui-shared/Forms/ProductSectionForm'
import SectionWrapper from 'ui-shared/LayoutComponents/SectionWrapper'

const RentSectionEdit: React.FC = () => {
  return (
    <SectionWrapper title={'resources.rentsections.editSection'}>
      <Edit>
        <ProductSectionForm
          entity="rents"
          toolbar={<WithDeleteModalToolbar />}
        />
      </Edit>
    </SectionWrapper>
  )
}

export default RentSectionEdit
